import type { FC } from 'react';

type NavBarToggleButtonProps = {
  isExpanded: boolean;
  onToggle(): void;
};

const NavBarToggleButton: FC<NavBarToggleButtonProps> = ({ isExpanded, onToggle }) => {
  return (
    <button
      onClick={onToggle}
      title={isExpanded ? 'Contraer' : 'Expandir'}
      style={{
        position: 'absolute',
        right: -12,
        top: 28,
        width: 22,
        height: 22,
        borderRadius: '50%',
        background: '#FFFFFF',
        border: '1px solid #E5ECEE',
        color: '#253746',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 1px 3px rgba(0,0,0,.08)',
        zIndex: 10,
        flexShrink: 0,
        padding: 0,
      }}
    >
      {isExpanded ? (
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
          <path
            d="M15 6l-6 6 6 6"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
          <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </button>
  );
};

export default NavBarToggleButton;
